import { createContext, useCallback, useContext, useState, type PropsWithChildren } from 'react';

import '../foundations/tokens.css';
import '../foundations/typography.css';
import '../foundations/layout.css';
import '../components.css';
import '../motion.css';
import '../control-system.css';
import { UIFontFaces } from '../foundations/UIFontFaces.js';

const DianaUIPortalContext = createContext<HTMLElement | undefined>(undefined);

export function useDianaUIPortal(): HTMLElement {
  const portal = useContext(DianaUIPortalContext);

  if (portal === undefined) {
    throw new Error('Diana UI overlay components require DianaUIProvider');
  }

  return portal;
}

export function DianaUIProvider({ children }: PropsWithChildren) {
  const [portal, setPortal] = useState<HTMLDivElement | null>(null);
  const capturePortal = useCallback((node: HTMLDivElement | null) => {
    setPortal(node);
  }, []);

  return (
    <div className="diana-ui" data-testid="ui-scope">
      <UIFontFaces />
      <div
        ref={capturePortal}
        className="diana-ui-portal"
        data-testid="ui-portal"
        data-portal-id="primary"
      />
      {portal === null ? null : (
        <DianaUIPortalContext.Provider value={portal}>{children}</DianaUIPortalContext.Provider>
      )}
    </div>
  );
}
